import { NotificationLogoProps } from ".";
import { CustomerTransactionPayload } from "@lib/types/Notification";
import { GrMoney } from "react-icons/gr";
import { CustomerLogo } from "@lib/components/MiniComponents/Others";

export default function CustomerManualTransactionRequestLogo(
  props: NotificationLogoProps,
) {
  const { notification, onlyIcon = false } = props;
  const payload = notification?.payload as CustomerTransactionPayload;
  const customer = { ...payload?.customer, ...payload?.transaction?.customer };

  if (onlyIcon) {
    return <GrMoney />;
  }

  return <CustomerLogo customer={customer} />;
}
